/* ============================================================================
   EMSOIR — ANA SAYFA MOTION · Hafif, mobil öncelikli, GPU dostu.
   Sakura petal + scroll reveal + header cam + hero parallax + slider progress.
   ============================================================================ */
(function () {
  "use strict";
  var REDUCED = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function ready(fn){ document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); }

  /* Ana sayfa kapsamı: hero varsa body'ye emh-home ekle (header/footer premium olur) */
  function scopeHome(){
    if (document.querySelector(".emh-hero")) document.body.classList.add("emh-home");
  }

  /* Sakura yaprakları — [data-emh-petals] alanlarına düşen yapraklar */
  function initPetals(){
    if (REDUCED) return;
    var zones = document.querySelectorAll("[data-emh-petals]");
    zones.forEach(function(zone){
      var count = parseInt(zone.getAttribute("data-emh-petals"), 10) || 14;
      // mobilde daha az yaprak (performans)
      if (window.innerWidth < 750) count = Math.min(count, 9);
      var frag = document.createDocumentFragment();
      for (var i=0;i<count;i++){
        var p = document.createElement("span");
        p.className = "emh-petal";
        var size = 26 + ((i*11)%26);
        var left = (i * 97 + 13) % 100;
        var dur = 9 + ((i*5)%10);
        var delay = -((i*3)%14);
        var drift = ((i%2===0)?1:-1) * (30 + (i*11)%60);
        p.style.left = left + "%";
        p.style.width = size + "px"; p.style.height = Math.round(size*0.64) + "px";
        p.style.animationDuration = dur + "s";
        p.style.animationDelay = delay + "s";
        p.style.setProperty("--emh-drift", drift + "px");
        p.style.opacity = (0.5 + (i%3)*0.2).toFixed(2);
        frag.appendChild(p);
      }
      zone.appendChild(frag);
    });
  }

  /* Scroll reveal */
  function initReveal(){
    if (REDUCED || !("IntersectionObserver" in window)) {
      document.querySelectorAll(".emh-up").forEach(function(el){ el.classList.add("emh-in"); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("emh-in"); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    document.querySelectorAll(".emh-up").forEach(function(el){ io.observe(el); });
  }

  /* Header: kaydırınca cam */
  function initHeader(){
    if (!document.body.classList.contains("emh-home")) return;
    function onScroll(){
      document.body.classList.toggle("emh-scrolled", (window.pageYOffset||0) > 80);
    }
    onScroll(); window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Hero parallax (arka plan çok hafif kayar) + slider progress otomatik ilerler */
  function initHero(){
    var hero = document.querySelector(".emh-hero");
    if (!hero) return;
    var bg = hero.querySelector(".emh-hero__bg");
    if (bg && !REDUCED){
      var ticking=false;
      window.addEventListener("scroll", function(){
        if(ticking) return; ticking=true;
        window.requestAnimationFrame(function(){
          var y = window.pageYOffset||0;
          if (y < window.innerHeight) bg.style.transform = "scale(1.02) translate3d(0," + (y*0.06).toFixed(1) + "px,0)";
          ticking=false;
        });
      }, { passive: true });
    }
    // Slider progress bar (görsel dolum döngüsü)
    var bar = hero.querySelector(".emh-hero__progress-fill");
    var idxEl = hero.querySelector(".emh-hero__idx");
    if (bar && !REDUCED){
      var i=1, total=3;
      setInterval(function(){
        i = i%total + 1;
        if (idxEl) idxEl.textContent = "0"+i;
      }, 4000);
    }
  }

  /* Video popup (Reels — TAM EKRAN, click-to-play, kapatilinca sayfa HER ZAMAN normale doner) */
  function initVideoPopup(){
    var pop = document.querySelector("[data-emh-vpop]");
    if (!pop) return;
    var media = pop.querySelector(".emh-vpop__media");
    var video = pop.querySelector("video");
    var isOpen = false;

    /* Scroll-lock HER durumda geri alinabilsin: govdeye class (inline style'a guvenmeyiz) */
    function lockScroll(){
      document.documentElement.classList.add("emh-vpop-lock");
      document.body.classList.add("emh-vpop-lock");
    }
    function unlockScroll(){
      document.documentElement.classList.remove("emh-vpop-lock");
      document.body.classList.remove("emh-vpop-lock");
    }
    /* iOS'ta video kendi native tam ekranina girdiyse cikaralim (aksi halde kapanma takilir) */
    function exitFS(){
      try {
        if (document.fullscreenElement && document.exitFullscreen) { document.exitFullscreen(); }
        else if (document.webkitFullscreenElement && document.webkitExitFullscreen) { document.webkitExitFullscreen(); }
        else if (video && video.webkitDisplayingFullscreen && video.webkitExitFullscreen) { video.webkitExitFullscreen(); }
      } catch(e){}
    }
    function open(e){
      if (e && e.preventDefault) e.preventDefault();
      if (isOpen) return;
      isOpen = true;
      pop.hidden = false; pop.setAttribute("aria-hidden", "false");
      lockScroll();
      if (video) {
        /* Muted autoplay = tarayici engellemez; kullanici controls ile sesi acabilir */
        video.muted = true; video.setAttribute("muted", ""); video.setAttribute("playsinline", "");
        try { video.currentTime = 0; } catch(e2){}
        var p = null;
        try { p = video.play(); } catch(e3){}
        if (p && p.catch) p.catch(function(){});
      } else if (media && media.getAttribute("data-vid") && !media.querySelector("iframe")) {
        var id = media.getAttribute("data-vid"), t = media.getAttribute("data-vtype");
        var src = t === "vimeo" ? "https://player.vimeo.com/video/" + id + "?autoplay=1&muted=1&playsinline=1"
                                : "https://www.youtube.com/embed/" + id + "?autoplay=1&mute=1&rel=0&playsinline=1";
        var ifr = document.createElement("iframe");
        ifr.src = src; ifr.setAttribute("allow","autoplay; encrypted-media; fullscreen"); ifr.setAttribute("allowfullscreen","");
        media.appendChild(ifr);
      }
    }
    /* close() HICBIR kosulda unlockScroll'dan ONCE patlamaz — sayfa daima acilir */
    function close(){
      isOpen = false;
      pop.hidden = true; pop.setAttribute("aria-hidden", "true");
      unlockScroll();
      exitFS();
      if (video) { try { video.pause(); } catch(e){} }
      else if (media) { var ifr = media.querySelector("iframe"); if (ifr) ifr.remove(); }
    }
    document.querySelectorAll("[data-emh-vopen]").forEach(function(b){ b.addEventListener("click", open); });
    pop.querySelectorAll("[data-emh-vclose]").forEach(function(b){ b.addEventListener("click", function(e){ if (e && e.preventDefault) e.preventDefault(); close(); }); });
    /* Bos alana (video disi zemin) tiklama da kapatir */
    pop.addEventListener("click", function(e){ if (e.target === pop) close(); });
    /* Esc her zaman kapatir */
    document.addEventListener("keydown", function(e){ if ((e.key === "Escape" || e.key === "Esc") && isOpen) close(); });
  }

  /* Hero arka plan videosu — mobilde oynar + ilk etkileşimde OTOMATİK çok kısık ses (tarayıcı sesli autoplay engeller) */
  function initHeroVideo(){
    var v = document.querySelector(".emh-hero__bgvid");
    if (!v) return;
    v.muted = true; v.setAttribute("muted", ""); v.setAttribute("playsinline", "");
    function tryPlay(){ try { var p = v.play(); if (p && p.catch) p.catch(function(){}); } catch(e){} }
    tryPlay();
    v.addEventListener("loadeddata", tryPlay);
    var done = false;
    function softSound(){
      if (done) return; done = true;
      try { v.muted = false; v.volume = 0.12; } catch(e){}
      tryPlay();
      document.removeEventListener("click", softSound);
      document.removeEventListener("touchstart", softSound);
      document.removeEventListener("scroll", softSound);
      document.removeEventListener("keydown", softSound);
    }
    document.addEventListener("click", softSound);
    document.addEventListener("touchstart", softSound, { passive: true });
    document.addEventListener("scroll", softSound, { passive: true });
    document.addEventListener("keydown", softSound);
  }

  ready(function(){
    scopeHome();
    initHeroVideo();
    initPetals();
    initReveal();
    initHeader();
    initHero();
    initVideoPopup();
    document.addEventListener("shopify:section:load", function(){ initPetals(); initReveal(); });
  });
})();


/* ===== HIZ EMSOIR prefetch: ic linkleri hover(65ms)/touchstart'ta ONDEN yukle ->
   tiklaninca sayfa ANINDA acilir (instant.page mantigi). Sepet/checkout/account HARIC. ===== */
(function(){
  if(!('querySelector' in document)) return;
  var done = {}, origin = location.origin, hoverT;
  function prefetch(url){
    if(done[url]) return; done[url] = 1;
    var l = document.createElement('link'); l.rel = 'prefetch'; l.href = url; l.as = 'document';
    try { document.head.appendChild(l); } catch(e){}
  }
  function ok(a){
    if(!a || !a.href) return false;
    if(a.origin !== origin) return false;
    if(a.hasAttribute('download') || a.target === '_blank') return false;
    if(/\/(cart|checkout|account|challenge)(\/|$|\?)/.test(a.pathname)) return false;
    if(a.getAttribute('href') && a.getAttribute('href').charAt(0) === '#') return false;
    return true;
  }
  document.addEventListener('mouseover', function(e){
    var a = e.target.closest && e.target.closest('a'); if(!ok(a)) return;
    hoverT = setTimeout(function(){ prefetch(a.href); }, 65);
  }, {passive:true});
  document.addEventListener('mouseout', function(){ clearTimeout(hoverT); }, {passive:true});
  document.addEventListener('touchstart', function(e){
    var a = e.target.closest && e.target.closest('a'); if(ok(a)) prefetch(a.href);
  }, {passive:true});
})();
